import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EditBundleItemsPage } from 'src/app/modals/edit-bundle-items/edit-bundle-items.page';
import { BundleItemModel } from 'src/app/models/bundle-item.model';
import { DetaillineDTOModel } from 'src/app/models/detaillineDTO.model';
import { DocumentModel } from 'src/app/models/document.model';

@Component({
  selector: 'bundle-items',
  templateUrl: './bundle-items.component.html',
  styleUrls: ['./bundle-items.component.scss'],
})
export class BundleItemsComponent implements OnInit {

  @Input() document: DocumentModel;
  @Input() customerRepairItem : DetaillineDTOModel;

  
  constructor( public modalController: ModalController ) { }

  ngOnInit() {
    console.log("BundleItems document")
    console.log(document);
    console.log("--------------------");
  }




  async editAccessories() {
    const modal = await this.modalController.create({
        component: EditBundleItemsPage,
        cssClass: 'modal-fullscreen',
        backdropDismiss: false,
        componentProps: {
            document: this.document,
            customerRepairItem : this.customerRepairItem
        }
    });

    modal.onDidDismiss().then((dataReturned) => {
       
    });





    return await modal.present();
  }



}
